import { render } from "./BasicChip.vue?vue&type=template&id=552b3b09&scoped=true&ts=true"
import script from "./BasicChip.vue?vue&type=script&lang=ts"
export * from "./BasicChip.vue?vue&type=script&lang=ts"

import "./BasicChip.vue?vue&type=style&index=0&id=552b3b09&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552b3b09"]])

export default __exports__